import NothingHereImage from '@/../img/no-activity.png';
import React from 'react';
import styled from 'styled-components';

const NothingHereImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f6f9ff;
  margin-bottom: 50px;
  font-size: 20px;
  font-weight: 600;
  line-height: 50px;
  color: rgba(0, 0, 0, 0.65);
`;

function NoContentPlaceHolder() {
  return (
    <NothingHereImgContainer>
      <img src={NothingHereImage} alt="No activity" />
      Nothing here yet.
    </NothingHereImgContainer>
  );
}

export default NoContentPlaceHolder;
